export default [
	{
		key: 'icon',
		label: ''
	},
	{
		key: 'timestamp',
		label: 'Date/Time',
		sorteable: true
	},
	{
		key: 'customerName',
		label: 'Client'
	},
	{
		key: 'dealerNumberAndCompany',
		label: 'DealerNumber (Co)'
	},
	{
		key: 'bodType',
		label: 'BOD Type'
	},
	{
		key: 'bodVersion',
		label: 'BOD Version'
	},
	{
		key: 'requestUri',
		label: 'Request'
	},
	{
		key: 'responseUri',
		label: 'Reponse'
	},
	{
		key: 'duration',
		label: 'Duration'
	}
];
